"use client";

import * as React from "react";
import { cn } from "@baluu/ui/lib/utils";
import { Button } from "../button";

type CalloutBoxProps = {
  title: string;
  description?: string;
  buttonText?: string;
  onButtonClick?: () => void;
  variant?: "default" | "primary" | "warning" | "info";
  className?: string;
  children?: React.ReactNode;
};

const variantStyles = {
  default: "bg-muted text-foreground",
  primary: "bg-primary text-primary-foreground",
  warning: "bg-yellow-100 dark:bg-yellow-900 text-yellow-700 dark:text-yellow-300",
  info: "bg-blue-100 dark:bg-blue-900 text-blue-700 dark:text-blue-300",
} as const;

function CalloutBox({
  title,
  description,
  buttonText,
  onButtonClick,
  variant = "primary",
  className,
  children,
}: CalloutBoxProps) {
  return (
    <div className={cn("rounded-lg p-6", variantStyles[variant], className)}>
      <h3 className="font-bold text-lg uppercase tracking-wide">{title}</h3>
      {description && <p className="mt-2 opacity-90">{description}</p>}
      {children}
      {buttonText && onButtonClick && (
        <Button
          variant={variant === "primary" ? "secondary" : "outline"}
          onClick={onButtonClick}
          className="mt-4"
        >
          {buttonText}
        </Button>
      )}
    </div>
  );
}

export { CalloutBox };
